class RTE {
  constructor() {
    this.rte();
  }

  rte() {

    /**
     * Rich Text Editor
     * -----------------------------------------------------------------------------
     * Wrap iframes and tables in div tags to force responsive/scrollable layout.
     *
     * @namespace rte
     */

    theme.rte = {

      /**
       * Wrap tables in a container div to make them scrollable when needed
       *
       * @param {object} options - Options to be used
       * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
       * @param {string} options.tableWrapperClass - table wrapper class name
       */
      wrapTable(options) {
        const tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

        options.$tables.wrap(`<div class="${tableWrapperClass}"></div>`);
      },

      /**
       * Wrap iframes in a container div to make them responsive
       *
       * @param {object} options - Options to be used
       * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
       * @param {string} options.iframeWrapperClass - class name used on the wrapping div
       */
      wrapIframe(options) {
        const iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

        options.$iframes.each(function() {
          // Add wrapper to make video responsive
          $(this).wrap(`<div class="${iframeWrapperClass}"></div>`);

          // Re-set the src attribute on each iframe after page load
          // for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791
          // Need to specifically target video and admin bar
          this.src = this.src;
        });
      },
    };

    $(document).ready(() => {

      // Target tables to make them scrollable
      const tableSelectors = '.rte table';

      theme.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
      });

      // Target iframes to make them responsive
      const iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' +
        '.rte iframe[src*="player.vimeo"]';

      theme.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper',
      });
    });
  }

}

export default RTE;
